import moment from 'moment'
import React, {useState} from 'react'
import Select from 'react-select'
import Text from 'react-text'
import update from 'immutability-helper'
import {makeStyles} from 'external/material'
import Button from '@mui/material/Button'
import {uuid} from '../../../helpers/utils'
import {Consumer} from '../../../context'
import AddFieldMenu from './add-field'
import TemplatesMenu from './templates-menu'
import confirmDialog from '../../confirm-dialog'
import {createPlanSection} from '../../../helpers/planning'
import {savePlan} from '../../../context/post'
import './topbar.styl'
import { cloneDeep } from 'lodash'

const buttonStyles = makeStyles({
  root: {
    color: '#4e576e',
    width: '145px',
    textTransform: 'none',
    background: '#fff',
    '&:first-child': {
      'margin-left': '9px'
    },
    '&:hover': {
      background: '#eaf5ff'
    }
  }
})

const defaultDates = {
  month: (date) => ({
    start: moment(date).startOf('month').startOf('week').format('YYYY-MM-DD'),
    end: moment(date).endOf('month').endOf('week').format('YYYY-MM-DD')
  }),
  week: (date) => ({
    start: moment(date).startOf('week').format('YYYY-MM-DD'),
    end: moment(date).endOf('week').format('YYYY-MM-DD')
  }),
  day: (date) => ({
    start: moment(date).format('YYYY-MM-DD'),
    end: moment(date).format('YYYY-MM-DD')
  })
}

export default function TopBar (props) {

  const buttonClasses = buttonStyles()
  const { plan, validation, fieldsMenu=undefined } = props

  return (<Consumer>{ context => {

    const {planTemplates, translate, navigate, link} = context
    const templates = planTemplates.map(template => (
      template.label == 'default'
        ? {...template, label: translate('default_template_label')}
        : template
    )).map((template) => ({...template, label: template.label.replace('rd-', '')}))


    const template = templates.find(({value}) => value === context.query.template)

    const applyTemplate = option => {
      const {value: template, label} = option
      if (context.query.template !== template) {
        confirmDialog({
          className: 'apply-template',
          translate: translate,
          children: (
            <div className="message">
              <div className="question">
                {translate('confirm_apply_template')}
              </div>
              <div className="title">
                {label}
              </div>
            </div>
          ),
          onConfirm: () => {
            const query = {template}
            navigate({}, context.match.path, {preserveQuery: true, query})
          }
        })
      }
    }

    const addItem = (item) => () => {
      const {content} = item
      const id = uuid()
      const sections = content.sections.map(createPlanSection)
      const items = update(plan.items, {$push: [{...item, id, content: {...content, sections}}]})
      props.updatePlan({...plan, items},() => {
        const wrapper = document.getElementById('new-plan')
        const field = document.getElementById(id)
        wrapper.scrollTo({top: field.offsetTop, behavior: 'smooth'})
      })
    }

    const currentItems = (plan.items || []).reduce((acc, {name}) => {
      acc[name] = true
      return acc
    },{})

    const templateItems = context.templateItems
      .filter(item => item.name == 'annotations' || !currentItems[item.name])
      .map(field => ({...field, addItem: addItem(field)})) 

    return (
      <div className="topbar">
        <AddFieldMenu fields={fieldsMenu ?? templateItems} rd={props?.rd}/>
        <TemplatesMenu {...{plan, context}} rd={props?.rd}/>
        <div className="apply-template">
          <Select
            className="templates"
            classNamePrefix="select-"
            isSearchable={false}
            value={template}
            onChange={applyTemplate}
            options={templates}
          />
        </div>
        <div style={{display: 'flex', flexGrow: 1}} />
        <div className="cancel">
          <Button
            variant="contained"
            className={buttonClasses.root}
            onClick={() => {
              context.navigate({view: context.newPlanFrom},'/:languageId/:role/:page/:view',{query: context.newPlanFromQuery})
            }}
          >
            <Text id="cancel_label" />
          </Button>
        </div>
        <div className="save">
          <Button
            variant="contained"
            className={buttonClasses.root}
            disabled={!validation.canSave}
            onClick={async () => {
              const planToSave = cloneDeep(plan)
              planToSave.content = planToSave.content || {}
              planToSave.content.source = context.page
              await savePlan(planToSave, template ? template.id : undefined)
              const query = {...context.newPlanFromQuery, ...defaultDates[context.newPlanFrom](plan.start)}
              context.navigate({view: context.newPlanFrom},'/:languageId/:role/:page/:view',{query})
            }}
          >
            <Text id="save-plan-label"/>
          </Button>
        </div>
      </div>
    )}}</Consumer>)
}
